import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { Layout } from '@/components/layout';
import IconCard from '@/assets/icons/heroIcons/Card-front.svg';
import IconThird from '@/assets/icons/heroIcons/Icon-third.svg';
import IconMaxi from '@/assets/icons/heroIcons/Maxi.svg';
import MoreInfoSection from '@/sections/MoreInfo';
import { SectionDelimiter } from '@/components/SectionDelimiter';
import { Text } from '@/components/typography';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import { useTranslation } from 'react-i18next';
import { LINKS } from '@/constants/links';
import React from 'react';
import IconDeferredPayment from '@/assets/icons/heroIcons/Deferred-payment.svg';
import HeroSimple from '@/sections/HeroSimple';
import { ContactForm } from '@/sections/whistleblowing/ContactForm';
import { SeoHeader } from '@/components/SeoHeader';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
import IconShoppingCart from '@/assets/icons/heroIcons/Shopping-cart.svg';
import IconMobile from '@/assets/icons/heroIcons/Device-mobile.svg';
import IconUser from '@/assets/icons/heroIcons/User-group.svg';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
interface Props extends IntlProps {
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(t0) {
  const $ = _c(32);
  const {
    menuPromoBanners
  } = t0;
  usePageView("whistleblowing");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["whistleblowing", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const isCsLanguage = useIsSelectedLanguage("cs");
  let t2;
  if ($[1] !== t) {
    t2 = t("seo.title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("seo.description");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <SeoHeader title={t2} description={t3} />;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("banner.title");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("banner.text");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <Text variant="p1" className="mx-auto mt-4 max-w-192 text-gray-800 lg:mt-8">{t6}</Text>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t7) {
    t8 = <HeroSimple title={t5}>{t7}</HeroSimple>;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="px-4"><div className="relative z-10 mx-auto max-w-192 pb-20 lg:pb-40"><ContactForm /></div></div>;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8) {
    t10 = <div className="bg-blue-50">{t8}{t9}</div>;
    $[18] = t8;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <SectionDelimiter color="bg-blue-100" background="bg-blue-50" />;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== isCsLanguage || $[22] !== t) {
    t12 = <div className="relative z-10"><MoreInfoSection buttons={isCsLanguage ? [{
        analyticsParam: "whistleblowingMoreInfoDeferredPayment",
        icon: <IconDeferredPayment className="fillButtonIcon" />,
        testId: "whistleblowingMoreInfoDeferredPayment",
        title: t("core:products.deferredPayment"),
        to: LINKS().deferredPayment
      }, {
        analyticsParam: "whistleblowingMoreInfoRevolvingApplication",
        icon: <IconMaxi className="fillButtonIcon" />,
        testId: "whistleblowingMoreInfoRevolvingApplication",
        title: t("core:products.revolving"),
        to: LINKS().revolving
      }, {
        analyticsParam: "whistleblowingMoreInfoPayInThree",
        icon: <IconThird className="fillButtonIcon" />,
        testId: "whistleblowingMoreInfoPayInThree",
        title: t("core:link.payInThree"),
        to: LINKS().payInThree
      }, {
        analyticsParam: "whistleblowingMoreInfoCard",
        icon: <IconCard className="fillButtonIcon" />,
        testId: "whistleblowingMoreInfoCard",
        title: t("core:products.card"),
        to: LINKS().card
      }] : [{
        analyticsParam: "whistleblowingMoreInfoPayInThree",
        icon: <IconThird className="fillButtonIcon" />,
        testId: "whistleblowingMoreInfoPayInThree",
        title: t("core:products.payInThree"),
        to: LINKS().payInThree
      }, {
        analyticsParam: "whistleblowingMoreInfoWhereToShop",
        icon: <IconShoppingCart className="fillButtonIcon" />,
        testId: "whistleblowingMoreInfoWhereToShop",
        title: t("core:products.whereToShop"),
        to: LINKS().whereToShop
      }, {
        analyticsParam: "whistleblowingMobileApp",
        icon: <IconMobile className="fillButtonIcon" />,
        testId: "whistleblowingMoreInfoMobileApp",
        title: t("core:products.mobileApp"),
        to: LINKS().mobileApp
      }, {
        analyticsParam: "whistleblowingMoreInfoAboutCompany",
        icon: <IconUser className="fillButtonIcon" />,
        testId: "whistleblowingMoreInfoAboutCompany",
        title: t("core:link.aboutUs"),
        to: LINKS().aboutCompany
      }]} /></div>;
    $[21] = isCsLanguage;
    $[22] = t;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="bgCircle absolute right-0 bottom-0 translate-x-1/4 translate-y-1/4 rotate-180" />;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t12) {
    t14 = <div className="relative overflow-hidden bg-blue-100">{t12}{t13}</div>;
    $[25] = t12;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== menuPromoBanners || $[28] !== t10 || $[29] !== t14 || $[30] !== t4) {
    t15 = <Layout menuPromoBanners={menuPromoBanners}>{t4}{t10}{t11}{t14}</Layout>;
    $[27] = menuPromoBanners;
    $[28] = t10;
    $[29] = t14;
    $[30] = t4;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  return t15;
}
export const getStaticProps: GetStaticProps = async ctx => ({
  props: {
    menuPromoBanners: await getAllPageMenuPromoBanners(),
    ...(await getIntlProps(ctx, ['core', 'whistleblowing']))
  }
});